import { render, staticRenderFns } from "./authorization-manager.vue?vue&type=template&id=891fdf34&"
import script from "./authorization-manager.vue?vue&type=script&lang=js&"
export * from "./authorization-manager.vue?vue&type=script&lang=js&"
import style0 from "./authorization-manager.vue?vue&type=style&index=0&id=891fdf34&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports